import { render, staticRenderFns } from "./FacesDenteHistoricoItem.vue?vue&type=template&id=a555ea22&scoped=true"
import script from "./FacesDenteHistoricoItem.vue?vue&type=script&lang=js"
export * from "./FacesDenteHistoricoItem.vue?vue&type=script&lang=js"
import style0 from "./FacesDenteHistoricoItem.vue?vue&type=style&index=0&id=a555ea22&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a555ea22",
  null
  
)

export default component.exports